import { render, staticRenderFns } from "./FirstApplicationForm.vue?vue&type=template&id=bc08fbac&"
import script from "./FirstApplicationForm.vue?vue&type=script&lang=ts&"
export * from "./FirstApplicationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports